// client/src/pages/Admin/ResourceManager/hooks/useDebounce.ts
import { useState, useEffect, useRef } from 'react';
import { DEBOUNCE_DELAY } from '../constants/resource.constants';

export const useDebounce = <T>(value: T, delay: number = DEBOUNCE_DELAY): [T, React.Dispatch<React.SetStateAction<T>>] => {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        timerRef.current = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [value, delay]);

    return [debouncedValue, setDebouncedValue];
};